// extracted by mini-css-extract-plugin
export var layout = "styles-module--layout--jfAUS";
export var contentWrapper = "styles-module--contentWrapper--Hs1By";